/* exported handleColorSwatchSizeChange */
function handleColorSwatchSizeChange(variant) {
  const siblingProductWrapper = document.querySelector(".boa-sibling-products");
  if (!siblingProductWrapper) return;
  siblingProductWrapper.querySelectorAll(".sibling-product").forEach((swatch) => {
    const variants = JSON.parse(swatch.dataset.variants);
    const selectedVariant = variants[variant.title];
    swatch.classList.toggle("product-sold-out", !selectedVariant.available);
    const swatchImage = swatch.querySelector("img");
    if (swatchImage) {
      swatchImage.classList.toggle("product-sold-out-image", !selectedVariant.available);
    }
  });
}

document.addEventListener("variant:changed", function (event) {
  const variant = event.detail.variant;
  handleColorSwatchSizeChange(variant);
});

document.addEventListener("DOMContentLoaded", () => {
  const siblingProductsElement = document.querySelector(".boa-sibling-products");
  if (siblingProductsElement) {
      const { firstVariantOption } = siblingProductsElement.dataset;
      if (firstVariantOption) {
        handleColorSwatchSizeChange({ title: firstVariantOption });
      }
  }

});
